export type ReportSetupExportSettingsTypeOriginal = {
  salaryDeductionCodeDevice: string | null
  salaryDeductionCodeUsage: string | null
  salaryDeductionCodeBuyout: string | null
  projectDevice: string | null
  projectUsage: string | null
  departmentOverrideDevice: string | null
  departmentOverrideUsage: string | null
}

export type ReportType =
  | 'off-boarding'
  | 'onboarding'
  | 'accounting'
  | 'tax-advantage'
  | 'consumption'
  | 'salary-deduction-usage'
  | 'ssd-order'
  | 'new-number-orders'
  | 'offboarding'

export type ReportFilters = {
  selectedReportType: ReportType
  fromDate?: string
  toDate?: string
  isGlobal: boolean
  year?: string | number
  selectedCustomer?: number
}

export type ExportReportNames = 'ssd-order' | 'salary-deduction-usage' | 'accounting'

export const EXPORT_OPTIONS = {
  VISMA_LONN: 'visma_lonn',
  VISMA_LONN_V2: 'visma_lonn_v2',
  VISMA_LONN_V3: 'visma_lonn_v3',
  VISMA_PAYROLL: 'visma_payroll',
  HULDT_OG_LILLEVIK: 'huldt_og_lillevik',
  HULDT_OG_LILLEVIK_SDV: 'huldt_og_lillevik_sdv',
  SAP: 'sap',
  SAP_V2: 'sap_v2',
  TRIPLETEX: 'tripletex',
  CUSTOMER_SPECIFIC: 'customer_specific',
  VISMA_GLOBAL: 'visma_global',
  SD_WORKS_ADITRO: 'sd_works_aditro',
} as const

export type ExportOptionsType = (typeof EXPORT_OPTIONS)[keyof typeof EXPORT_OPTIONS]

export type ExportFiltersType = {
  reportName: ExportReportNames
  formatName: ExportOptionsType
  countryId: number
  fromDate: string
  toDate: string
  isGlobal: boolean
  customerId?: number
}
